import { Directive, forwardRef } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';

function validateInt32() {
	return (c: UntypedFormControl) => {
		if (c.value === null || c.value === '') return null; 
		  
	  
		const value = Number(c.value);
		if (isNaN(value)) return { notANumber: true }; 
		if (!Number.isInteger(value)) return {int32: { valid:false, notInteger: true }};
		  
		const minInt32 = -2147483648;
		const maxInt32 = 2147483647;	 	
		if (value < minInt32 || value > maxInt32) return {int32: { valid:false, outOfInt32Range: true }}; 
		
		return null; 
	};
}

@Directive({
	selector: '[appInt32Validator]', // Attribute selector
	providers: [
		{provide: NG_VALIDATORS, useExisting: forwardRef(() => Int32ValidatorDirective), multi: true}
	]
})
export class Int32ValidatorDirective implements Validator {

	validator: Function;

	constructor() {
		this.validator = validateInt32();
	}

	validate(c: UntypedFormControl) {
		return this.validator(c);
	}

}
